import React from "react";
import Link from "@/utils/link";

const Breadcrumbs = ({ links }) => {
    return (
        <div className="flex space-x-4">
            {links.map((link, index) => (
                <div
                    key={link.name}
                    className={link.hideMobile ? "last:hidden sm:last:flex" : "flex"}
                >
                    {index > 0 ? <span className="mr-4">/</span> : null}
                    <Link href={link.href}>
                        <a className="text-primary-500 hover:underline">{link.name}</a>
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default Breadcrumbs;
